"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSafari = isSafari;

function isSafari() {
  return navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && !navigator.userAgent.match('CriOS');
}